export enum ApplicationProductEnum {
  AUTOCALLER = "AUTOCALLER",
  DASHBOARD_USERS = "USERS",
  REAPIT_INTEGRATION = "REAPIT_INTEGRATION",
  MORTGAGES = "MORTGAGES",
  LEAD_PARSER = "LEAD_PARSER",
  INTEGRATIONS_TAB = "INTEGRATIONS_TAB",
  DEVELOPERS_TAB = "DEVELOPERS_TAB",
}
